export default "<div>\n    <div id=\"map\" style=\"width: 100%; height: 300px;\"></div>\n</div>";